import { Link } from 'react-router-dom';
import { BRAND } from '@sb2/shared';
import { useLocale } from '../../i18n/LocaleContext';
import { useAuth } from '../AuthContext';

export function HomePage() {
  const { ensureGuest } = useAuth();
  const { t } = useLocale();

  return (
    <section className="hero">
      <div className="hero-copy">
        <h1 className="hero-title">
          <span className="hero-mark" aria-hidden="true">
            {BRAND.logo}
          </span>
          <span className="sr-only">{BRAND.name}</span>
        </h1>
        <p className="lede">{t('homeLede')}</p>
        <div className="cta-row">
          <Link
            className="btn primary"
            to="/solo"
            onClick={() => {
              void ensureGuest();
            }}
          >
            {t('homePlaySolo')}
          </Link>
          <Link
            className="btn"
            to="/lobby"
            onClick={() => {
              void ensureGuest();
            }}
          >
            {t('homeMultiplayer')}
          </Link>
          <Link
            className="btn"
            to="/solo?mode=daily"
            onClick={() => {
              void ensureGuest();
            }}
          >
            {t('homeDaily')}
          </Link>
        </div>
      </div>
      <div className="hero-visual" aria-hidden>
        <div className="timer-ring">
          <div className="timer-face">
            <span className="timer-hand" />
            <span className="timer-hub" />
          </div>
        </div>
      </div>
    </section>
  );
}
